import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebSidenavComponent } from './web-sidenav.component';
import { MaterialModuleWeb } from '../material/material.module';



@NgModule({
  declarations: [
    WebSidenavComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleWeb,
  ],
  exports:[
    WebSidenavComponent
  ]
})
export class WebSidenavModule { }
